import { render, staticRenderFns } from "./BillNewAppointmentList.vue?vue&type=template&id=36e80e2c"
import script from "./BillNewAppointmentList.vue?vue&type=script&lang=js"
export * from "./BillNewAppointmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports